import { useCallback, useEffect, useState } from 'react';

import { useDebounceCallback } from '@xemplo/hooks';

import { WindowSize } from './use-window-resize.types';

/**
 * This is a common hook used in lot of components to implemented responsive design.
 * Extracting this to a shared file so we can expand this as per need.
 * Yet to refactor other components having this duplicated code
 */

export const useWindowResize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = useCallback(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }, [setWindowSize]);

  const debouncedHandleResize = useDebounceCallback(handleResize, 200);

  useEffect(() => {
    window.addEventListener('resize', debouncedHandleResize);
    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, [debouncedHandleResize]);

  return {
    windowSize,
    isSmallScreen: windowSize.width < 1024, //BreakpointSizeV2.medium
  };
};
